import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  InfoOutlined
} from '@ant-design/icons'
import { Button, Flex, Popconfirm } from 'antd'

import { useLocales } from 'src/locales'

type Props = {
  editingIndex: number | undefined
  isEditing: boolean
  preventDefault?: boolean
  showConfirmDelete?: boolean
  onSave: () => void
  onCancel: () => void
  onEdit: () => void
  onDelete?: () => void
  onDetails?: () => void
  isLoading?: boolean
  disabled?: boolean
}

export const SubmitButtons = ({
  editingIndex,
  isEditing,
  preventDefault,
  showConfirmDelete,
  onCancel,
  onSave,
  onEdit,
  onDelete,
  onDetails,
  isLoading = false,
  disabled = false
}: Props) => {
  const { t } = useLocales()

  const handleClick =
    (callback: () => void) => (event: React.MouseEvent<HTMLButtonElement>) => {
      if (preventDefault) {
        event.preventDefault()
        event.stopPropagation()
      }
      callback()
    }

  return (
    <Flex gap={8} align="center" justify="center">
      {isEditing ? (
        <Flex gap={8}>
          <Button
            icon={<CloseOutlined />}
            onClick={handleClick(onCancel)}
            disabled={isLoading || disabled}
          />
          <Button
            icon={<CheckOutlined />}
            type="primary"
            onClick={handleClick(onSave)}
            loading={isLoading}
            disabled={disabled}
          />
        </Flex>
      ) : (
        <Flex gap={8}>
          <Button
            icon={<EditOutlined />}
            disabled={editingIndex !== undefined || disabled}
            onClick={handleClick(onEdit)}
          />

          {onDelete && (
            <>
              {showConfirmDelete ? (
                <Popconfirm
                  title={t('treatments.confirm_delete_adverse_reactions')}
                  onConfirm={() => onDelete()}
                  disabled={editingIndex !== undefined || disabled}
                >
                  <Button
                    icon={<DeleteOutlined />}
                    danger
                    disabled={editingIndex !== undefined || disabled}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Popconfirm>
              ) : (
                <Button
                  icon={<DeleteOutlined />}
                  danger
                  disabled={editingIndex !== undefined || disabled}
                  onClick={handleClick(onDelete)}
                  loading={isLoading}
                />
              )}
            </>
          )}
        </Flex>
      )}
      {onDetails && (
        <Button icon={<InfoOutlined />} onClick={handleClick(onDetails)} />
      )}
    </Flex>
  )
}
